// API utility functions
const getApiUrl = () => {
  return process.env.REACT_APP_API_URL || "http://localhost:8000";
};

export const submitContact = async (contactData) => {
  const apiUrl = getApiUrl();
  const url = `${apiUrl}/api/contact`;
  
  console.log("Submitting contact to:", url);
  console.log("Contact data:", contactData);
  
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactData),
    });

    console.log("Response status:", response.status);
    console.log("Response ok:", response.ok);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response:", errorText);
      throw new Error(`Failed to submit contact request: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    console.log("Success response:", data);
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError")) {
      throw new Error("Cannot connect to server. Please make sure the backend is running on port 8000.");
    }
    throw error;
  }
};

export const fetchContacts = async () => {
  const apiUrl = getApiUrl();
  const response = await fetch(`${apiUrl}/api/contact`);

  if (!response.ok) {
    throw new Error("Failed to fetch contacts");
  }

  return response.json();
};

export const submitWaitlist = async (waitlistData) => {
  const apiUrl = getApiUrl();
  const url = `${apiUrl}/api/waitlist`;
  
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(waitlistData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to submit waitlist request: ${response.status} ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Waitlist error:", error);
    if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError")) {
      throw new Error("Cannot connect to server. Please make sure the backend is running.");
    }
    throw error;
  }
};

